import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "../api";
import { Button, Card, CardContent, Input, Label } from "../components/ui";
import { Plus, Trash2 } from "lucide-react";

export default function Aliases() {
  const [items, setItems] = useState([]);
  const [original, setOriginal] = useState("");
  const [replacement, setReplacement] = useState("");
  const load = async () => {
    try { const r = await api.get("/aliases"); setItems(r.data); } catch { }
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!original.trim() || !replacement.trim()) return;
    try { await api.post("/aliases", { original, replacement, active: true }); toast.success("Alias salvo"); setOriginal(""); setReplacement(""); load(); }
    catch (e) { toast.error(fmtErr(e)); }
  };
  const remove = async (o) => {
    try { await api.delete(`/aliases/${encodeURIComponent(o)}`); load(); }
    catch (e) { toast.error(fmtErr(e)); }
  };
  return (
    <div className="max-w-3xl">
      <h1 className="font-display text-4xl uppercase leading-none mb-6">Nomes TTS</h1>
      <Card>
        <CardContent className="p-6 space-y-4">
          <div className="text-xs text-gray-400">
            Corrige a pronúncia sem alterar o nome exibido no RaceFacer. Ex.: <em>Ocupe&apos;s booking driver 1 → Ocupe&apos;s, piloto 1</em>
          </div>
          <div>
            <Label>Novo alias</Label>
            <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-2">
              <Input data-testid="alias-original" value={original} onChange={(e) => setOriginal(e.target.value)} placeholder="Nome original" />
              <Input data-testid="alias-replacement" value={replacement} onChange={(e) => setReplacement(e.target.value)} placeholder="Substituir por" />
              <Button data-testid="alias-add" onClick={add}><Plus size={14} className="mr-1" /> Adicionar</Button>
            </div>
          </div>
          <div className="space-y-1">
            {items.length === 0 && <div className="text-sm text-gray-500 py-2">Nenhum alias cadastrado.</div>}
            {items.map((a) => (
              <div key={a.id} className="flex items-center gap-2 p-2 border border-panel text-sm">
                <div className="flex-1"><span className="text-gray-500">{a.original}</span> → <span className="text-white">{a.replacement}</span></div>
                <button className="text-red-400 hover:bg-red-400/10 p-1.5 rounded-sm" onClick={() => remove(a.original)}><Trash2 size={14} /></button>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
